module.exports = __webpack_public_path__ + "img/symbol_10.641c8d17.png";